import { apiAuth, apiResponseType } from ".";

export const getReportsData = (params?: {
  report_type_id?: number;
  start_date?: string;
  end_date?: string;
  unity_id?: number;
  report_status_id?: number;
  page?: string | number;
}): apiResponseType => {
  const searchParams = new URLSearchParams();

  if (params?.report_type_id) {
    searchParams.append("report_type_id", params.report_type_id.toString());
  }
  if (params?.start_date) {
    searchParams.append("start_date", params.start_date);
  }
  if (params?.end_date) {
    searchParams.append("end_date", params.end_date);
  }
  if (params?.unity_id) {
    searchParams.append("unity_id", params.unity_id.toString());
  }
  if (params?.report_status_id) {
    searchParams.append("report_status_id", params.report_status_id.toString());
  }
  if (params?.page) {
    searchParams.append("page", params.page.toString());
  }

  return apiAuth.get(`report?${searchParams.toString()}`);
};

export const getReportTypes = (): apiResponseType =>
  apiAuth.get("report/types");

export const searchReportData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`report?name=${params.name}`);


export const generateReport = (data: {
  name: string;
  report_type_id: number;
  start_date?: string;
  end_date?: string;
  unity_id?: any;
  sale_type_id?: any;
  payment_form_id?: any;
  seller_id?: any;
  sale_status_id?: any[];
}): apiResponseType => {
  const cleanedData: any = { ...data };
  Object.entries(cleanedData).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length === 0) {
      cleanedData[key] = undefined;
    }
  });
  return apiAuth.post("report/generate", cleanedData);
};

export const deleteReportData = (uuid: string) =>
  apiAuth.delete(`report/${uuid}/destroy`) as apiResponseType;
